export default {
    content: {
        items: {
        }
    }
}
